<!-- eslint-disable max-len -->
<template>
    <teleport to="head">
        <title>{{ HEAD_TITLE }} | Acuerdo de Confidencialidad y Acceso a Materiales de Clase</title>
    </teleport>
    <UnauthNav />
    <div v-if="user.id">
        <MobileControls />
    </div>
    <IphoneBar />
    <div class="lcu-nonDash-wrap" :class="{ 'lcu-logged-dashWrap': user.id }">
        <SecondaryNav />
        <div class="lcu-page">
            <section class="section">
                <header class="lcu-section-header lcu-center-text">
                Acuerdo de Confidencialidad y Acceso a Materiales de Clase | Legacy Christian University
                </header>
            </section>
            <section class="section">
                <p>
                    Este Acuerdo de Confidencialidad y Acceso a Materiales de Clase ("Acuerdo") se celebra entre
                    Legacy Christian University ("LCU") y el estudiante, miembro del profesorado, personal o
                    participante autorizado abajo firmante ("Receptor").
                </p>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">1. Propósito</h2>
                <div class="lcu-term-section">
                    <p>
                        El propósito de este Acuerdo es proteger la propiedad intelectual, el contenido académico y los
                        materiales instructivos propietarios de Legacy Christian University. Esto incluye garantizar que
                        todos los materiales de clase se utilicen únicamente para fines educativos autorizados y no
                        sean distribuidos, copiados o compartidos de manera indebida.
                    </p>
                    <!-- <ul>
                        <li class="lcu-acc-bullet">
                            <strong>Datos de la Cuenta</strong> - Para utilizar ciertas funciones (como acceder
                            a contenido), usted necesita crear una
                            cuenta de usuario, lo cual requiere que recopilemos y almacenemos su dirección de
                            correo electrónico, contraseña y configuración de la cuenta. A medida que utilice
                            ciertas funciones del sitio, es posible que se le solicite proporcionar información
                            adicional. Por ejemplo, usted puede optar por proporcionar su número de teléfono
                            para mensajes promocionales y fines de autenticación, o información relacionada con
                            sus intereses de aprendizaje, incluyendo ocupación e intereses de habilidades. Al crear
                            la cuenta, le asignamos un número identificador único.
                        </li>
                        <li class="lcu-acc-bullet">
                            <strong>Datos del Perfil</strong> - Usted también puede optar por proporcionar
                            información de perfil como una fotografía, idioma, país u otros datos. Sus Datos
                            de Perfil pueden ser visibles públicamente para otros usuarios.
                        </li>
                        <li class="lcu-acc-bullet">
                            <strong>Datos de Aprendizaje</strong> - Cuando usted accede al contenido, recopilamos
                            ciertos datos, incluyendo qué
                            programas, tareas, laboratorios, espacios de trabajo y cuestionarios ha iniciado y
                            completado; contenido; certificados de finalización; insignias; sus intercambios con
                            instructores, asistentes de enseñanza y otros estudiantes; y ensayos, respuestas a
                            preguntas y otros elementos enviados para cumplir con los requisitos del programa y
                            del contenido relacionado.
                        </li>
                        <li class="lcu-acc-bullet">
                            <strong>Datos de Pago del Estudiante</strong> - Si usted realiza compras, recopilamos
                            ciertos datos sobre su compra (como su nombre,
                            dirección de facturación y código postal) según sea necesario para procesar su pedido
                            y que pueden guardarse opcionalmente para procesar pedidos futuros. Usted debe
                            proporcionar ciertos datos de pago y facturación directamente a nuestros proveedores
                            de servicios de pago, incluyendo su nombre, información de tarjeta de crédito,
                            dirección de facturación y código postal. También podemos recibir información
                            limitada, como el hecho de que usted tiene una nueva tarjeta y los últimos cuatro
                            dígitos de esa tarjeta, de los proveedores de servicios de pago para facilitar los pagos.
                            Por razones de seguridad, Legacy Christian University no recopila ni almacena datos
                            sensibles del titular de la tarjeta, como números completos de tarjetas de crédito o
                            datos de autenticación de tarjetas.
                        </li>
                        <li class="lcu-acc-bullet">
                            <strong>Promociones y Encuestas</strong> - Podemos invitarle a completar una encuesta
                            o participar en una promoción (como un
                            concurso, sorteo o desafío), ya sea a través de los Servicios o de una plataforma de
                            terceros. Si usted participa, recopilaremos y almacenaremos los datos que proporcione
                            como parte de su participación, tales como su nombre, dirección de correo
                            electrónico, dirección postal, fecha de nacimiento o número de teléfono. Dichos datos
                            están sujetos a esta Política de Privacidad, a menos que se indique lo contrario en las
                            reglas oficiales de la promoción o en otra política de privacidad. Los datos recopilados
                            se utilizarán para administrar la promoción o encuesta, incluyendo la notificación de
                            ganadores y la distribución de premios. Para recibir un premio, puede ser necesario
                            que nos permita publicar públicamente parte de su información. Cuando utilizamos
                            una plataforma de terceros para administrar una encuesta o promoción, se aplicará la
                            política de privacidad de dicho tercero.
                        </li>
                        <li class="lcu-acc-bullet">
                            <strong>Comunicaciones y Soporte</strong> - Si usted se comunica con nosotros para
                            recibir soporte o para reportar un problema o
                            inquietud (independientemente de si ha creado una cuenta), recopilamos y
                            almacenamos su información de contacto, mensajes y otros datos sobre usted, como
                            su nombre, dirección de correo electrónico, ubicación, ID de usuario y cualquier otro
                            dato que proporcione o que recopilemos por medios automatizados (descritos más
                            adelante). Utilizamos estos datos para responderle e investigar su consulta o inquietud.
                        </li>
                    </ul> -->
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">2. Definición de Materiales Confidenciales</h2>
                <div class="lcu-term-section">
                    <p>
                        "Materiales Confidenciales" incluyen, pero no se limitan a:
                    </p>
                    <ul>
                        <li class="lcu-acc-bullet">Clases (en vivo o grabadas)</li>
                        <li class="lcu-acc-bullet">Presentaciones y diapositivas de cursos</li>
                        <li class="lcu-acc-bullet">Notas de clase y materiales impresos</li>
                        <li class="lcu-acc-bullet">Contenido digital de aprendizaje</li>
                        <li class="lcu-acc-bullet">Videos, grabaciones de audio y transcripciones</li>
                        <li class="lcu-acc-bullet">Materiales de plataformas de aprendizaje</li>
                        <li class="lcu-acc-bullet">Exámenes, cuestionarios, tareas y evaluaciones</li>
                        <li class="lcu-acc-bullet">Contenido creado por instructores</li>
                        <li class="lcu-acc-bullet">Cualquier otro material académico o instructivo proporcionado por LCU</li>
                    </ul>
                    <p>
                        Los Materiales Confidenciales también incluyen materiales de backend, nivel de sistema y
                        acceso a plataformas, incluyendo contenido accedido a través de roles administrativos,
                        técnicos o de desarrollo, ya sea visible para usuarios finales o no.
                    </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">3. Acceso y Uso</h2>
                <div class="lcu-term-section">
                    <p>
                        Se otorga al Receptor un acceso limitado e intransferible a los Materiales Confidenciales
                        únicamente para fines académicos, administrativos o técnicos autorizados relacionados con
                        cursos inscritos, operaciones institucionales o actividades académicas autorizadas.
                    </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">4. Acciones Prohibidas</h2>
                <div class="lcu-term-section">
                    <p>
                        Esta sección aplica a todas las personas, incluyendo pero no limitándose a estudiantes,
                        profesores, personal, contratistas, personal de TI y desarrolladores web que tengan acceso
                        directo o indirecto a los sistemas o materiales de LCU.
                    </p>
                    <p>
                        El Receptor acepta expresamente que no deberá, sin autorización escrita de Legacy Christian
                        University:
                    </p>
                    <ul>
                        <li class="lcu-acc-bullet">
                            Compartir o distribuir cualquier material de clase
                        </li>
                        <li class="lcu-acc-bullet">
                            Copiar o reproducir cualquier material
                        </li>
                        <li class="lcu-acc-bullet">
                            Tomar capturas de pantalla de cualquier contenido
                        </li>
                        <li class="lcu-acc-bullet">
                            Grabar pantalla de cualquier contenido
                        </li>
                        <li class="lcu-acc-bullet">
                            Fotografiar cualquier material
                        </li>
                        <li class="lcu-acc-bullet">
                            Descargar o almacenar materiales fuera de plataformas autorizadas
                        </li>
                        <li class="lcu-acc-bullet">
                            Publicar o subir materiales en línea o redes sociales
                        </li>
                        <li class="lcu-acc-bullet">
                            Transmitir cualquier material a terceros
                        </li>
                        <li class="lcu-acc-bullet">
                            Usar materiales con fines comerciales
                        </li>
                        <li class="lcu-acc-bullet">
                            Modificar o adaptar materiales
                        </li>
                    </ul>
                    <p>
                       Esta prohibición aplica a todos los formatos, incluyendo digital, físico, audio, video, fotográfico,
                       acceso backend, nivel de base de datos, nivel de sistema y formas administrativas. 
                    </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">4A. Cláusula de Acceso Técnico, de Desarrollo y Administrativo</h2>
                <div class="lcu-term-section">
                    <p>
                        Cualquier persona con acceso a sistemas, plataformas, servidores, bases de datos, sistemas
                        de gestión de contenido, sistemas de aprendizaje o infraestructura digital de LCU —
                        incluyendo, pero no limitado a desarrolladores web, desarrolladores de software, personal de
                        TI, administradores de sistemas, contratistas, consultores, proveedores y terceros — está
                        estrictamente sujeta a este Acuerdo.
                    </p>
                    <p>
                        Dichas personas no deberán, bajo ninguna circunstancia y sin importar su nivel de acceso o
                        capacidad técnica:
                    </p>
                    <ul>
                        <li class="lcu-acc-bullet">
                            Distribuir cualquier material institucional o de clase
                        </li>
                        <li class="lcu-acc-bullet">
                            Compartir contenido interna o externamente
                        </li>
                        <li class="lcu-acc-bullet">
                            Copiar o duplicar materiales
                        </li>
                        <li class="lcu-acc-bullet">
                            Tomar capturas de pantalla
                        </li>
                        <li class="lcu-acc-bullet">
                            Grabar pantalla
                        </li>
                        <li class="lcu-acc-bullet">
                            Extraer datos, medios o contenido de los sistemas
                        </li>
                        <li class="lcu-acc-bullet">
                            Replicar bases de datos o repositorios de contenido
                        </li>
                        <li class="lcu-acc-bullet">
                            Reproducir contenido de la plataforma
                        </li>
                        <li class="lcu-acc-bullet">
                            Usar materiales para fines personales, comerciales o externos
                        </li>
                        <li class="lcu-acc-bullet">
                            Transferir contenido entre sistemas sin autorización
                        </li>
                    </ul>
                    <p>
                        Todo acceso se concede únicamente para fines operativos institucionales, y no para uso
                        personal, portafolios, demostraciones, entrenamiento, pruebas o desarrollo fuera de proyectos
                        autorizados por LCU.
                    </p>
                    <p>
                        Cualquier violación de esta cláusula se considerará un incumplimiento material de este Acuerdo
                        y puede resultar en terminación inmediata del acceso, cancelación contractual, acciones
                        disciplinarias, acciones legales y responsabilidad financiera.
                    </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">5. Derechos de Propiedad Intelectual</h2>
                <div class="lcu-term-section">
                    <p>
                       Todos los Materiales Confidenciales siguen siendo propiedad exclusiva de Legacy Christian
                        University y/o sus instructores. No se transfieren derechos de propiedad mediante el acceso o
                        uso.
                    </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">6. Obligación de Confidencialidad</h2>
                <div class="lcu-term-section">
                    <p>
                        El Receptor acepta mantener estricta confidencialidad sobre todos los Materiales
                        Confidenciales y tomar medidas razonables para prevenir acceso, divulgación o uso no
                        autorizado.
                    </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">7. Vigencia</h2>
                <div class="lcu-term-section">
                    <p>
                       Este Acuerdo permanecerá vigente durante la inscripción o afiliación del Receptor con Legacy
                        Christian University y continuará vigente después de la terminación de dicha relación.
                    </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">8. Incumplimiento y Recursos</h2>
                <div class="lcu-term-section">
                    <p>
                       Cualquier violación de este Acuerdo puede resultar en:
                    </p>
                    <ul>
                        <li class="lcu-acc-bullet">
                            Acción disciplinaria
                        </li>
                        <li class="lcu-acc-bullet">
                            Revocación de acceso a materiales
                        </li>
                        <li class="lcu-acc-bullet">
                            Sanciones académicas
                        </li>
                        <li class="lcu-acc-bullet">
                            Terminación de inscripción o afiliación
                        </li>
                        <li class="lcu-acc-bullet">
                            Acciones legales
                        </li>
                        <li class="lcu-acc-bullet">
                            Responsabilidad financiera por daños
                        </li>
                    </ul>
                    <p>
                        LCU se reserva todos los derechos y recursos disponibles bajo la ley.
                    </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">9. No Renuncia</h2>
                <div class="lcu-term-section">
                    <p>
                        El hecho de que LCU no haga cumplir alguna disposición de este Acuerdo no constituye una
                        renuncia al derecho de hacer cumplir dicha disposición en el futuro.
                    </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">10. Ley Aplicable</h2>
                <div class="lcu-term-section">
                    <p>
                        Este Acuerdo se regirá e interpretará de acuerdo con las leyes del estado y jurisdicción
                        aplicable en la que opera Legacy Christian University.
                    </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">11. Firma Electrónica y Aceptación Digital</h2>
                <div class="lcu-term-section">
                    <p>
                        Este Acuerdo puede ejecutarse electrónicamente. Las firmas electrónicas, confirmaciones
                        digitales y aceptaciones mediante clic tendrán la misma validez legal que las firmas
                        manuscritas. Al firmar o aceptar electrónicamente este Acuerdo, el Receptor consiente el uso
                        de registros y firmas electrónicas conforme a la ley aplicable, incluyendo la Electronic 
                        Signatures in Global and National Commerce Act (ESIGN) y la Uniform Electronic Transactions
                        Act (UETA).
                    </p>
                </div>
            </section>
            <section class="section">
                <h2 class="lcu-term-header">12. Reconocimiento y Aceptación</h2>
                <div class="lcu-term-section">
                    <p>
                        Al acceder, ver, descargar o utilizar cualquier material de clase, el Receptor reconoce que ha
                        leído, entendido y acepta cumplir con este Acuerdo.
                    </p>
                </div>
            </section>
            <section class="section">
                <p>
                    <i>
                        Este documento es confidencial y está destinado únicamente para uso autorizado por
                        Legacy Christian University.
                    </i>
                </p>
            </section>
        </div>
        <Footer />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Footer from 'ç/footer/Footer.vue';
import SecondaryNav from 'ç/nav/SecondaryNav.vue';
import MobileControls from 'ç/nav/MobileControls.vue';
import IphoneBar from 'ç/nav/iphone-bar/IphoneBar.vue';
import UnauthNav from 'ç/nav/UnauthNav.vue';

export default {
  name: 'program-terms',
  computed: {
    ...mapGetters(['user']),
  },
  components: {
    UnauthNav,
    Footer,
    MobileControls,
    IphoneBar,
    SecondaryNav,
  },
};
</script>

<style scoped lang="scss">
.lcu-acc-bullet {
  margin-bottom: 15px;
}

.lcu-term-header {
  font-size: 18px;
  font-weight: bold;
}

.lcu-term-section {
  padding-left: 25px;

  @media only screen and (max-width: $mobile-max) {
   padding-left: 0;
  }
}

.lcu-term-link {
  text-decoration: underline;
  color: $legacy-secondary;

  &:hover {
    text-decoration: none;
  }
}
</style>
